/** @format */

export class NamedException {
    public id: string;
    public message: string;

    public constructor(id: string, message: any) {
        this.id = id;
        this.message = message;
    }
}
